var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMatchRequestsS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.10857 15.4972C2.1203 15.875 2.13205 16.254 2.13205 16.6329C6.04755 16.6329 9.96304 16.6329 13.8988 16.6261C13.0428 15.8305 12.2594 14.9149 12.2594 14.1927C12.2594 12.1681 14.7921 11.1556 16.0434 13.0142C16.1075 12.9192 16.1745 12.8317 16.244 12.7515C15.7627 10.7814 14.1189 9.48476 11.9116 9.47473H9.92459C11.9236 8.76849 13.0129 7.27222 12.7854 5.50064C12.558 3.76497 11.1814 2.43629 9.48169 2.31659C7.78194 2.19688 6.22583 3.28617 5.77096 4.93805C5.49565 5.94354 5.63929 6.90115 6.17795 7.77497C6.7166 8.66076 7.53057 9.17547 8.51212 9.45079C8.07996 9.47073 7.65519 9.47221 7.23166 9.47369C6.89265 9.47487 6.55444 9.47605 6.21386 9.4867C4.19091 9.54655 2.40737 11.0308 2.15599 13.0418C2.05737 13.8472 2.08289 14.6696 2.10857 15.4972Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M15.9953 13.2434C14.9617 11.7083 12.8698 12.5446 12.8698 14.2169C12.8698 15.4726 15.7377 17.437 15.9953 17.6924C16.2547 17.437 18.98 15.4726 18.98 14.2169C18.98 12.5573 17.0308 11.7083 15.9953 13.2434V13.2434Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchRequestsS);
export default __webpack_public_path__ + "static/media/match_requests_s.393ff738b9983bccca91ca8983c41886.svg";
export { ForwardRef as ReactComponent };